import { createTheme, PaletteColorOptions } from "@mui/material";
import { green, orange } from "@mui/material/colors";

const primary: PaletteColorOptions = {
  main: "#005030",
  contrastText: "#fff",
};

const secondary: PaletteColorOptions = {
  main: "#ff9800",
  contrastText: "#fff",
};

export const theme = createTheme({
  spacing: 8,
  palette: {
    primary: primary,
    secondary: secondary,
    background: {
      default: primary.main,
    },
    common: {
      white: "#fff",
      black: "#000000DE",
    },
  },

  components: {
    MuiGrid: {
      styleOverrides: {
        container: {
          marginRight: -16,
          marginLeft: -16,
          width: "auto",
        },
        item: {
          position: "relative",
          width: "100%",
          minHeight: 1,
          paddingRight: 16,
          paddingLeft: 16,
          flexBasis: "auto",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        startIcon: {
          display: "block",
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          "&$active": {
            color: "inherit",
            fontWeight: "600 !important",
          },
          "&$completed": {
            color: "inherit",
            fontWeight: 300,
          },
        },
      },
    },
  },
});
